<template>
  <RevCard v-if="status === 'success'" class="p-24">
    <h2 class="heading-2 mb-8">
      {{ i18n(translations.manageWeekendDeliveryCardTitle) }}
    </h2>
    <p class="body-2 mb-16">
      {{ i18n(translations.manageWeekendDeliveryCardDescription) }}
    </p>
    <SetUpShippingConfiguration
      v-if="!data || data.totalAvailableMarkets === 0"
    />
    <SingleMarketWeekendDelivery
      v-else-if="data.totalAvailableMarkets === 1"
      :is-weekend-delivery-configured="data.isWeekendDeliveryConfigured"
      :weekend-delivery-configurations="data.configuration"
      @updated="refresh"
    />
    <MultipleMarketWeekendDelivery
      v-else
      :is-weekend-delivery-configured="data.isWeekendDeliveryConfigured"
      :weekend-delivery-configurations="data.configuration"
      @updated="refresh"
    />
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'

import translations from './ManageWeekendDelivery.translations'
import MultipleMarketWeekendDelivery from './components/MultipleMarketWeekendDelivery/MultipleMarketWeekendDelivery.vue'
import SetUpShippingConfiguration from './components/SetUpShippingConfiguration/SetUpShippingConfiguration.vue'
import SingleMarketWeekendDelivery from './components/SingleMarketWeekendDelivery/SingleMarketWeekendDelivery.vue'
import { useGetCarrierWeekendDeliveriesConfiguration } from './composables/useGetCarrierWeekendDeliveriesConfiguration'

const i18n = useI18n()

const { data, status, refresh } =
  await useGetCarrierWeekendDeliveriesConfiguration()
</script>
